import { Table } from "antd";
import { TableProps } from "antd/lib";

type Props<T> = TableProps<T> & {
  dataSource: T[];
  loading: boolean;
};

const AppColumnsTable = <T extends object>(props: Props<T>) => {
  return (
    <Table
      size={props?.size || "small"}
      {...props}
      pagination={false}
      className="ant-columns-table"
    />
  );
};

export default AppColumnsTable;
